import React, { Component } from "react"
import ReactHtmlParser from "react-html-parser"
import { handleClickTracking } from "../../helpers/tracking"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default class SectionPageHeader extends Component {
  render() {
    const { showButton, linkUrl, linkTracking, linkText, linkTarget } = this.props.button
    const target = SelectionFactoryHelper.getFromSelectionFactory(linkTarget)
    const backgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.backgroundColor)
    return (
      <div className={`section-page-header ${backgroundColor ?? ""}`}>
        <div className="w--wider">
          <div className="infohead">{this.props.title}</div>
          {ReactHtmlParser(this.props.heading)}
          <div className="maintext">{this.props.mainText}</div>
          {showButton ? (
            <a href={linkUrl} target={target} onClick={() => handleClickTracking(linkTracking)}>
              <div className="button button--medium button--general no-shadow">
                <span className="text">{linkText}</span>
              </div>
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
